import { render, staticRenderFns } from "./OrderChangeStatus.vue?vue&type=template&id=1a204e64&scoped=true&"
import script from "./OrderChangeStatus.vue?vue&type=script&lang=js&"
export * from "./OrderChangeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a204e64",
  null
  
)

export default component.exports